import { FormButtons, FormGrid } from '@app/components/various/Form';
import { Skeleton } from '@app/components/various/Skeleton';
import { useTranslation } from 'react-i18next';

export const CreateAccountFormSkeleton = () => {
  const { t } = useTranslation(['accounts', 'buyers', 'common', 'shipping', 'validation']);

  return (
    <>
      <h3 className="mb-4 heading-4">{t('accounts:account_one')}</h3>
      <FormGrid cols={2} colGap="medium">
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
      </FormGrid>
      <h3 className="mb-3 mt-6 heading-4">{t('buyers:buyer_one')}</h3>
      <FormGrid cols={2} colGap="medium">
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
      </FormGrid>
      <h3 className="mb-3 mt-6 heading-4">{t('shipping:shipping')}</h3>
      <FormGrid cols={2} className="mb-6">
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
        <Skeleton type="input" label />
      </FormGrid>
      <FormButtons>
        <div className="h-10 w-32">
          <Skeleton type="button" size="large" />
        </div>
        <div className="h-10 w-32">
          <Skeleton type="button" size="large" />
        </div>
      </FormButtons>
    </>
  );
};
